export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7888.5b68a29e.jpg";